var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        _vm._l(_vm.permList, function (item, index) {
          return _c("el-col", { key: index, staticClass: "ivu-mb pointer" }, [
            _c(
              "div",
              [
                _c(
                  "el-card",
                  {
                    attrs: {
                      bordered: false,
                      "dis-hover": "",
                      padding: 12,
                      shadow: "never",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "nav_item",
                        on: {
                          click: function ($event) {
                            return _vm.navigatorTo(item.url)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "pic_badge" }, [
                          _c("span", {
                            staticClass: "iconfont",
                            class: item.icon,
                            style: { color: item.bgColor },
                          }),
                        ]),
                        _c("p", { staticClass: "text-14" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }